import React, { useEffect, useState } from 'react'
import CloseIcon from "@mui/icons-material/Close";
import { Formik } from 'formik';
import * as yup from 'yup'
import { Button } from '@material-ui/core';
import { BsCamera } from 'react-icons/bs';
import { FaUserCircle } from 'react-icons/fa';
import { useAppDispatch, useAppSelector } from '../../useStore';
import { reset, userRegistration } from '../../features/Registration/registrationSlice';
import { Spinners } from '../TableOptions';
import toast, { Toaster } from 'react-hot-toast';


const RegisterModal = ({ setShowModal }) => {

	const dispatch = useAppDispatch()

	const { isError, isSuccess, message, isLoading } = useAppSelector((state: { registration: any; }) => state.registration)




	// const [firstname, setFirstName] = useState("");
	// const [lastname, setLastName] = useState("");
	// const [email, setEmail] = useState("");
	// const [phoneNumber, setPhoneNumber] = useState("");
	// const [client, setClient] = useState("");
	// const [role, setRole] = useState("");
	// const [password, setPassword] = useState("123456");
	// const [profilePic, setProfilePic] = useState("");
	const [showModal, setLgShow] = useState(false);
	const [previewImgLoading, setPreviewImgLoading] = useState(false);
	const [imgLocalURL, setImgLocalURL] = useState(null);



	const onSubmitRegistration = (values: any) => {
		const value: any = { ...values };
		// @ts-ignore 
		dispatch(userRegistration(value))
	}

	// const [inputs, setInputs] = useState({
	// 	firstname: "",
	// 	lastname: "",
	// 	email: "",
	// 	phonenumber: "",
	// 	userRole: "",
	// 	jobProfile: "",
	// 	password: "123456",
	// })
	// const handleOnChange = (input: any, value: any) => {
	// 	setInputs((prevState: any) => ({
	// 		...prevState,
	// 		[input]: value,
	// 	}));
	// };




	const loginValidationSchema = yup.object().shape({
		firstName: yup.string().required('First Name is Required'),
		LastName: yup.string().required('Last Name is Required'),
		email: yup.string().email("Please enter valid email").required('Email Address is Required'),
		role: yup.string().required('Please select role'),
		phoneNumber: yup.string().min(9, ({ min }) => `Password must be at least ${min} characters`)
			.required('Phone Number is required'),
		password: yup.string().min(6, ({ min }) => `Password must be at least ${min} characters`)
			.required('Password is required'),
	})


	useEffect(() => {
		if (isError) {
			toast.error(message);
		} else if (isSuccess) {
			toast.success("User Created!");
			setLgShow(!showModal);
		}
		dispatch(reset())
	}, [isError, message, dispatch, isSuccess, showModal])

	return (
		<>
			<Toaster
				position="top-center"
				toastOptions={{
					className: "",
					duration: 5000,
					success: {
						duration: 5000,
					},
				}}
			/>
			<Button
				className="view-HIRED-profile"
				style={{ height: "2rem" }}
				onClick={() => setLgShow(true)}>
				REGISTER USER
			</Button>
			{showModal && (
				<div className="pop_box">
					<div className="modal_container">
						<div className="modal_header">
							<h2> </h2>
							<div className="close_button">
								<CloseIcon
									sx={{ fontSize: 30 }}
									onClick={() => {
										setLgShow(!showModal);
									}}
								/>
							</div>
						</div>
						<Formik
							validationSchema={loginValidationSchema}
							initialValues={{
								firstName: '',
								LastName: '',
								email: '',
								phoneNumber: '',
								role: '',
								password: '',
							}}
							onSubmit={onSubmitRegistration}
						>
							{({ handleChange, handleSubmit, errors, values,
							}) => (
								<div>
									<div className="container">
										<div className="title">Registration</div>
										<form >
											<div className="user__details">
												<div className="input__box">
													<span className="details">First Name</span>
													<input type="text" placeholder="E.g: John Smith"
														value={values.firstName}
														onChange={handleChange("firstName")}
														required />
													{errors.firstName && <p className="formik-errors">{errors.firstName}</p>}
												</div>
												<div className="input__box">
													<span className="details">Last Name</span>
													<input type="text" placeholder="johnWC98"
														value={values.LastName}
														onChange={handleChange("LastName")}
														required />
													{errors.LastName && <p className="formik-errors">{errors.LastName}</p>}
												</div>
												<div className="input__box">
													<span className="details">Email</span>
													<input type="email" placeholder="johnsmith@hotmail.com"
														value={values.email}
														onChange={handleChange('email')}
														required />
													{errors.email && <p className="formik-errors">{errors.email}</p>}
												</div>
												<div className="input__box">
													<span className="details">Phone Number</span>
													<input type="tel" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" placeholder="012-345-6789"
														value={values.phoneNumber}
														onChange={handleChange("phoneNumber")}
														required />
													{errors.phoneNumber && <p className="formik-errors">{errors.phoneNumber}</p>}
												</div>
												<div className="input__box">
													<span className="details">Password</span>
													<input type="text" placeholder="123.eg"
														value={values.password}
														onChange={handleChange("password")} required />
													{errors.password && <p className="formik-errors">{errors.password}</p>}
												</div>

												<div className="input__box">
													<span className="details">Role</span>
													<select name="country" id="register-select"
														value={values.role}
														onChange={handleChange("role")}>
														<option value="">Select Role</option>
														<option value="HR_EXECUTIVE">HR EXECUTIVE</option>
														<option value=" HR_MANAGER"> HR MANAGER</option>
														<option value="ASSITANT_MANAGER">ASSITANT MANAGER</option>
														<option value="SUPER_ADMIN">SUPER ADMIN</option>
													</select>
													{errors.role && <p className="formik-errors">{errors.role}</p>}
												</div>
											</div>
											{/* @ts-ignore */}
											<center>
												{/* <p className='title'>
													{" "}
													{previewImgLoading
														? "Loading Image Please Wait...."
														: "Upload Image"}
												</p>
												<div className="avatar-upload">
													<div className="avatar-edit">
														<input
															type="file"
															id="imageUpload"
															accept=".png, .jpg, .jpeg"
															disabled={(previewImgLoading) && true}
														/>
														<label htmlFor="imageUpload">
															<BsCamera className="image-BsCamera" />
														</label>
													</div>
													<div className="avatar-preview">
														<div id="imagePreview">
															{imgLocalURL === null ? (
																<FaUserCircle className="AiOutlineUserAdd" />
															) : (
																<img
																	src={imgLocalURL}
																	alt="Profile Pic"
																	// @ts-ignore
																	className={previewImgLoading && "dark-img-loading"}
																/>
															)}
														</div>
													</div>
												</div> */}
												{/* @ts-ignore */}
											</center>
											<div className="Register-button-container">
												{isLoading ? <Spinners size={"sm"} /> :
													// @ts-ignore
													<Button
														onClick={handleSubmit}
														className="view-HIRED-profile"
														type="submit"
														// @ts-ignore
														id="primary"
														disabled={isLoading}
													>
														{"Register"}
													</Button>}
											</div>
										</form>
									</div>
								</div>
							)}
						</Formik>
					</div>
				</div>
			)}
		</>
	)
}

export default RegisterModal






